import { MetricName } from '@canvas/frontend-metrics';
import {
  cannotWrite,
  cannotAddComment,
  cannotDeleteComment,
} from '@canvas/policies/transient';

import { type AvailableModes, type Capabilities } from './types';

export const availableModes: Record<AvailableModes, Capabilities> = {
  readWrite: {
    key: 'readWrite',
    observability: {
      tag: 'eap',
      load: MetricName.BOARD_LOAD,
    },
    awareness: {
      selections: {
        canSend: true,
        canConsume: true,
      },
      telepointer: {
        canSend: true,
        canConsume: true,
      },
      transient: {
        canSend: true,
        canConsume: true,
      },
    },
    updates: {
      canSend: true,
      canConsume: true,
    },
    policies: [],
    interface: {
      mainToolbar: { visible: true },
      navigation: { visible: true },
      metadataFooter: { visible: false },
      zoomToSelection: { visible: true },
    },
  },
  embedded: {
    key: 'embedded',
    observability: {
      tag: 'eap-embedded',
      load: MetricName.BOARD_LOAD_EMBEDDED,
    },
    awareness: {
      selections: {
        canSend: true,
        canConsume: true,
      },
      telepointer: {
        canSend: true,
        canConsume: true,
      },
      transient: {
        canSend: true,
        canConsume: true,
      },
    },
    updates: {
      canSend: true,
      canConsume: true,
    },
    policies: [cannotWrite, cannotAddComment, cannotDeleteComment],
    interface: {
      mainToolbar: { visible: false },
      navigation: { visible: false },
      metadataFooter: { visible: true },
      zoomToSelection: { visible: false },
      disallowedTools: ['select'],
    },
  },
  historicalVersion: {
    key: 'historicalVersion',
    observability: {
      tag: 'eap-historical-version',
      load: MetricName.BOARD_LOAD_HISTORICAL,
    },
    awareness: {
      selections: {
        canSend: false,
        canConsume: false,
      },
      telepointer: {
        canSend: true,
        canConsume: true,
      },
      transient: {
        canSend: false,
        canConsume: false,
      },
    },
    updates: {
      canSend: false,
      canConsume: false,
    },
    interface: {
      mainToolbar: { visible: true },
      navigation: { visible: true },
      metadataFooter: { visible: false },
      zoomToSelection: { visible: true },
    },
    policies: [cannotWrite, cannotAddComment, cannotDeleteComment],
  },
};
